import Decimal from 'decimal.js'

/**
 * 将任意输入转成 Decimal，用于金额/数量计算。
 * - 空值/非法值按 0 处理
 * - 统一在这里做兜底，避免组件内到处 new Decimal(...) + ?? 0
 */
export const toDecimal = (value: unknown) => {
  try {
    // Decimal.js 对 null/undefined 支持不一致，统一转成 0
    if (value === null || value === undefined || value === '') return new Decimal(0)
    return new Decimal(value as Decimal.Value)
  } catch {
    return new Decimal(0)
  }
}

/**
 * 计算：数量 * 标准，返回 Decimal（便于继续 add / toFixed）。
 */
export const calcMulAmount = (count: unknown, standard: unknown) => {
  return toDecimal(count).mul(toDecimal(standard))
}

/**
 * 对列表做 Decimal 求和。
 */
export const sumDecimalBy = <T>(list: readonly T[], getValue: (item: T) => Decimal) => {
  return list.reduce((sum, item) => sum.add(getValue(item)), new Decimal(0))
}

/**
 * 对“其他项”这类结构求和（约定字段名为 value）。
 */
export const sumOtherItemsAmount = (others?: Array<{ value?: unknown }> | null) => {
  return sumDecimalBy(others ?? [], item => toDecimal(item?.value))
}
